import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ToastrUtilService {
  constructor(private toastr: ToastrService) {}

  showToastr(
    type: 'success' | 'error',
    message: string,
    otherProps: IndividualConfig | undefined = undefined
  ): void {
    this.toastr[type](
      message,
      '',
      otherProps
        ? otherProps
        : {
            progressBar: true,
            positionClass: 'toast-top-right',
          }
    );
    this.toastr.success;
  }
}
